(() => {

    let active = false;

    let dispatchActivity = () => {
        if (active) {
            return;
        }
        active = true;
        window.__userInteracted = true;
        document.dispatchEvent(new CustomEvent('UserInteracted'));
        document.querySelectorAll('img[data-deferred-gif]').forEach(img => {
            img.src = img.dataset.src;
        });
    };

    const interact = () => {
        let activities = [
            'mousedown',
            'mousemove',
            'keydown',
            'scroll',
            'touchstart',
            'click',
            'keypress',
            'touchmove'
        ];
        activities.forEach((activity) => {
            window.addEventListener(activity, dispatchActivity, false);
        });
    };

    if (document.readyState !== 'loading') {
        interact();
    } else {
        document.addEventListener('DOMContentLoaded', interact, false);
    }

})();
